var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('SkeletonLoaderTitleUpdate',{directives:[{name:"show",rawName:"v-show",value:(_vm.showSkeleton),expression:"showSkeleton"}]}),(_vm.canRender)?_c('div',[_c('CadastroRotas',{attrs:{"copy":true,"_id":_vm._id}})],1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }